import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

import { StepName } from './useBookingSteps';

interface UseStepNavigationProps {
  currentStep: StepName;
  previousStep: () => void;
}

export const useStepNavigation = ({ currentStep, previousStep }: UseStepNavigationProps) => {
  const router = useRouter();

  const handleBack = useCallback(() => {
    // select-time is always the first step — go back to the activity page
    if (currentStep === 'select-time') {
      router.back();
    } else {
      previousStep();
    }
  }, [currentStep, router, previousStep]);

  return {
    handleBack
  };
};
